import { render, staticRenderFns } from "./ComponentPropertiesModal.vue?vue&type=template&id=1f91d1e1&"
import script from "./ComponentPropertiesModal.vue?vue&type=script&lang=js&"
export * from "./ComponentPropertiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPropertiesModal.vue?vue&type=style&index=0&id=1f91d1e1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f91d1e1')) {
      api.createRecord('1f91d1e1', component.options)
    } else {
      api.reload('1f91d1e1', component.options)
    }
    module.hot.accept("./ComponentPropertiesModal.vue?vue&type=template&id=1f91d1e1&", function () {
      api.rerender('1f91d1e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ComponentPropertiesModal.vue"
export default component.exports